import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <div className="not-found__code">404</div>
      <h1 className="not-found__title">Page not found</h1>
      <p className="not-found__desc">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <button
        type="button"
        className="not-found__cta"
        onClick={() => navigate("/")}
      >
        Back to Overview
      </button>
    </div>
  );
}

export default NotFound;
